const FileIcon = ({ style, height }) => (
  <svg
    height={height}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.17 2.30357C10.8806 2.01414 10.3794 2.2118 10.3794 2.61418V5.07788C10.3794 6.10855 11.2548 6.96272 12.3207 6.96272C12.9913 6.96978 13.9232 6.96978 14.7209 6.96978C15.1233 6.96978 15.335 6.49681 15.0527 6.21444C14.0361 5.19083 12.2148 3.34835 11.17 2.30357Z"
      fill="#585E66"
    />
    <path
      d="M14.488 7.93588H12.4479C10.7748 7.93588 9.41237 6.57343 9.41237 4.90037V2.86023C9.41237 2.47197 9.0947 2.1543 8.70644 2.1543H5.71329C3.53902 2.1543 1.78125 3.56616 1.78125 6.08634V12.3409C1.78125 14.8611 3.53902 16.2729 5.71329 16.2729H11.2619C13.4362 16.2729 15.194 14.8611 15.194 12.3409V8.64181C15.194 8.25355 14.8763 7.93588 14.488 7.93588ZM8.13464 13.2727H5.31091C5.02148 13.2727 4.78146 13.0327 4.78146 12.7433C4.78146 12.4538 5.02148 12.2138 5.31091 12.2138H8.13464C8.42407 12.2138 8.66409 12.4538 8.66409 12.7433C8.66409 13.0327 8.42407 13.2727 8.13464 13.2727ZM9.5465 10.449H5.31091C5.02148 10.449 4.78146 10.209 4.78146 9.91955C4.78146 9.63012 5.02148 9.3901 5.31091 9.3901H9.5465C9.83593 9.3901 10.0759 9.63012 10.0759 9.91955C10.0759 10.209 9.83593 10.449 9.5465 10.449Z"
      fill="#585E66"
    />
  </svg>
);
export default FileIcon;
